import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
// import ReactHtmlParser from 'react-html-parser';
import { Timeline, message, Skeleton, Tooltip, Card, Empty, Typography, Modal, Drawer, Space, Pagination } from 'antd';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
// import { Scrollbars } from 'react-custom-scrollbars';
import MailDetailView from '../Email/MailDetailView';
import { UserCenterCard1 } from '../Pages/GlobalComponents/UserCardCmnts'
import { Button } from '../../../components/buttons/buttons';
import RelatedMeetingPopup from '../Popup/RelatedMeetingPopup';
import { findOneByMailService } from '../../../Api/Services/EmailApiSevices'
import { FetchAllLead, FetchAllLeadByDep } from '../../../Api/Services/LeadApiServices'
import { FetchAllContact, FetchAllContactByDep } from '../../../Api/Services/ContactApiService'
import { setReDirCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { NotesDetailData } from '../../../Api/Services/NotesapiServices'
import { CallLogDetailData } from '../../../Api/Services/CallLogApiService'
import { getAllActivityByType1, getAllActivityByType, updateActivityStatus, FetchAllAttendeeList } from '../../../Api/Services/CommonApiService'
// import { getByMeetingId } from '../../../Api/Services/MeetingApiService'
import { TaskDeatailsApi } from '../../../Api/Services/TaskapiService'
import { FetchUserDetails } from '../../../Api/Services/UserApiService'
import { AccountsIcon, CalendarIcon, CallLogIcon, CaseIcon, ContactIcon, DealIcon, EmailIcon, LeadIcon, NotesIcon, TaskIcon, CancelIcon } from '../../../components/Icons/Icons';
import { ExchangeCurrency, useExcryptedNavigation } from '../Filters/FilterConditions';
// import { TimelineNormalWrap } from '../Pages/ui-elements-styled';
import NotesPopup from '../Popup/NotesPopup'
import CallLog from '../Popup/CallLogPopup'

const { Text } = Typography;

const ActivityTimeline = ({ UrlId, trigger, NacTrigger, setNaCTrigger, emailactiontype, refreshTrigger, tabKey }) => {
    const PAGE_SIZE = 20;
    const isClickingRef = useRef(false);
    const skipOnChangeRef = useRef(false);
    const dispatch = useDispatch();
    const { emailapiValues } = useSelector((state) => state.EmailData);
    const localData = useSelector((state) => state.localRedux);
    const defaultCurrency = localData.currency
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const history = useHistory();
    const [activity, setActivity] = useState()
    const [apiType, setApiType] = useState()
    const [notePopup, setNotePopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [noteValue, setNoteValue] = useState()
    const [emailPopup, setEmailPopup] = useState(false)
    const [emailOpenId, setEmailOpenId] = useState()
    const [meetingPopup, setMeetingPopup] = useState(false)
    const [meetingOpenId, setMeetingOpenId] = useState()
    const [allattendeeData, setAllattendeeData] = useState()
    const [callLogPopup, setCallLogPopup] = useState(false)
    const [callLogValue, setCallLogValue] = useState()
    const [activityId, setActivityId] = useState()
    const [openPopup, setOpenPopup] = useState(false)
    const [loadingPage, setLoadingPage] = useState(true);
    const [allLeadList, setAllLeadList] = useState();
    const [totalCount, setTotalCount] = useState([])
    const [apiPage, setApiPage] = useState();
    const [tablePage, setTablePage] = useState();
    const [allContactList, setAllContactList] = useState();
    const [page, setPage] = useState()
    const { ExcryptedNavigation } = useExcryptedNavigation()
    const mergeUniqueById = (existing = [], incoming = [], idKey = 'activityId') => {
        const seen = new Set(existing.map(item => item[idKey]));
        return [...existing, ...incoming.filter(item => !seen.has(item[idKey]))];
    };
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2})/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    function formatDate(value, profile) {
        if (!value) return "";
        const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
        return moment(value).format(format);
    }
    const ViewTaskDetailPage = (type, id, status, allow) => {
        if (status === "Deleted") {
            message.info("Task does not exist")
        }
        else if (!allow) {
            message.info("Task does not exist")
        }
        else {
            dispatch(setReDirCall(null));
            ExcryptedNavigation("Nav", id, type, history, dispatch, null, null)
        }
    }
    // const ViewMeetingDetailPage = (type, id, status) => {
    //     if (status === "Deleted") {
    //         message.info("Meeting does not exist")
    //     }
    //     else {
    //         history.push(`/Home/details?${type}=${id}`);
    //     }
    // }
    const ViewNotePopup = (value, status) => {
        if (status === "Deleted") {
            message.info("Note does not exist")
        }
        else {
            setNotePopup(true)
            setPopupType("Update")
            setNoteValue(value)
            setPage("Entity")
            setNaCTrigger("trigger")
        }
    }
    const ViewCallLogPopup = (value, status) => {
        if (status === "Deleted") {
            message.info("Call Log does not exist")
        }
        else {
            setCallLogPopup(true)
            setPopupType("Update")
            setCallLogValue(value)
            setPage("Entity")
            setNaCTrigger("trigger")
        }
    }
    async function CreatorLedadListApi() {
        try {
            let Lead;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                Lead = await FetchAllLeadByDep()
            }
            else {
                Lead = await FetchAllLead()
            }
            setAllLeadList(Lead?.items)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function CreatorcontactListApi() {
        try {
            let contact;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                contact = await FetchAllContactByDep()
            }
            else {
                contact = await FetchAllContact()
            }
            setAllContactList(contact?.items)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function fetchTaskApi(taskId) {
        try {
            const response = await TaskDeatailsApi(taskId);
            const { allow, data } = response;
            const taskData = await { ...data, allow };
            return { apiCall: true, Data: taskData }
        } catch (error) {
            return { apiCall: false, Data: { task_name: "Unavailable", allow: false } };
        }
    }
    // async function fetchMeeting(meetingId) {
    //     try {
    //         const response = await getByMeetingId(meetingId);
    //         return { apiCall: true, Data: response };
    //     } catch (error) {
    //         return { apiCall: false };
    //     }
    // }
    async function fetchNote(noteId) {
        try {
            const response = await NotesDetailData(noteId);
            return { apiCall: true, Data: response };
        } catch (error) {
            return { apiCall: false, Data: { noteTittle: "Unavailable" } };
        }
    }
    async function fetchCallLog(callLogId) {
        try {
            const response = await CallLogDetailData(callLogId);
            return { apiCall: true, Data: response };
        } catch (error) {
            return { apiCall: false, Data: { CallTitle: "Unavailable" } };
        }
    }
    async function fetchChildEntityData(childEntity, childEntityId) {
        switch (childEntity) {
            case "Task":
                return fetchTaskApi(childEntityId);
            // case "Meeting":
            //     return fetchMeeting(childEntityId);
            case "Note":
                return fetchNote(childEntityId);
            case "Call log":
            case "Call Log":
                return fetchCallLog(childEntityId);
            default:
                return null;
        }
    }
    const ViewDetailPage = (id, type, userId, server, serverEmail) => {
        if (profile?.userId === userId || emailactiontype?.email?.toLowerCase() === serverEmail?.toLowerCase()) {
            if (server === emailactiontype?.emailType && id) {
                setEmailPopup(true)
                setPopupType(type)
                setEmailOpenId(id)
                setNaCTrigger("trigger")
            }
            else {
                message.info("Unable to retrieve the selected email. Please check your email settings or contact the administrator for support")
            }
        }
        else {
            message.info("Email details not found. Please contact your admin for details")
        }
    }
    const ViewDetailPage2 = (id, userId, server, serverEmail) => {
        if (profile?.userId === userId || emailactiontype?.email?.toLowerCase() === serverEmail?.toLowerCase()) {
            if (server === emailactiontype?.emailType && id) {
                setMeetingPopup(true)
                setMeetingOpenId(id)
                setNaCTrigger("trigger")
            }
            else {
                message.info("Unable to retrieve the selected Meeting. Please check your email settings or contact the administrator for support")
            }
        }
        else {
            message.info("Meeting details not found. Please contact your admin for details")
        }
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);
        return `${formattedDate} ${formattedTime}`;
    }
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = "YYYY-MM-DD";
        const timeFormat = "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);
        return `${formattedDate} ${formattedTime}`
    }
    function formatTimeDifference(startDateTime, endDateTime) {
        const start = new Date(startDateTime);
        const end = new Date(endDateTime);
        const diffMs = end - start;
        const diffMinutes = diffMs / (1000 * 60);
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;
        if (hours > 0) {
            return `${hours}h ${minutes}m`;
        }
        return `${minutes}m`;
    }
    const OutLookDateTimeForTimeZone = (dateTime) => {
        const DateTime = `${dateTime?.replace(/\.\d+/, "")}.000Z`;
        const formatedDateTime = moment(DateTime, "YYYY-MM-DDTHH:mm:ss.Z").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    const ZohoDateTimeForTimeZone = (dateTime) => {
        const formatedDateTime = moment(dateTime, "YYYYMMDDTHHmmssZ").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    function convertFromUTCAndFormat(dateTime, profile) {
        if (!dateTime || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }
        const utcTime = moment.parseZone(dateTime).utc();
        const converted = utcTime.clone().tz(toTimezone);
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);
        return { date: converted.format(dateFormat), time: formattedTime };
    }
    function convertFromUTCAndFormat1(dateTime, profile) {
        if (!dateTime || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }
        const utcTime = moment.utc(dateTime);
        const converted = utcTime.clone().tz(toTimezone);
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormatPref = (profile?.timeFormat?.toLowerCase() === "12hrs" || profile?.timeFormat?.toLowerCase() === '12-hour') ? "h:mm A" : "HH:mm";

        return {
            date: converted.format(dateFormat),
            time: converted.format(timeFormatPref)
        };
    }
    function convertFromUTCAndFormatForDifferent(dateTime, profile, dateFormat, type) {
        if (!dateTime || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profile.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }
        const utcTime = moment.parseZone(dateTime).utc();
        const converted = utcTime.clone().tz(toTimezone);
        const formattedDate = converted.format(dateFormat);
        const formattedTime = converted.format('h:mm a');

        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime1 = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${type === "1" ? formattedTime1 : formattedTime}`;
    }
    function convertFromUTCAndFormatForDifferent1(dateTime, profile, dateFormat, type) {
        if (!dateTime || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profile.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }
        const utcTime = moment.utc(dateTime);
        const converted = utcTime.clone().tz(toTimezone);
        const formattedDate = converted.format(dateFormat);
        const formattedTime = converted.format('h:mm a');

        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime1 = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${type === "1" ? formattedTime1 : formattedTime}`;
    }
    function formatAttendees(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();
        const filteredAttendees = attendeeList.filter(attendee => attendee.email?.toLowerCase() !== hostEmail?.toLowerCase() && !attendee.organizer);
        filteredAttendees.forEach(att => {
            const email = att.address || att.email
            if (!email) return;

            const apiMatch = apiAttendeesList.find(
                u => {
                    if (u.type === "User") {
                        if (linkby && u.id === linkby) {
                            return (
                                u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                                u.email?.toLowerCase() === email?.toLowerCase()
                            );
                        }
                        return (
                            u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                            u.email?.toLowerCase() === email?.toLowerCase()
                        );
                    }
                    return u.email?.toLowerCase() === email?.toLowerCase();
                });
            if (apiMatch && !includedEmails.has(email?.toLowerCase())) {
                attendeeData.push(apiMatch);
                includedEmails.add(email?.toLowerCase());
            }
        });
        if (configEmail && configEmail?.toLowerCase() !== hostEmail?.toLowerCase() && !includedEmails.has(configEmail?.toLowerCase()) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail?.toLowerCase(),
                email: configEmail?.toLowerCase(),
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function formatAttendees2(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();
        const filteredAttendees = attendeeList.filter(attendee => attendee.email?.toLowerCase() !== hostEmail?.toLowerCase());
        filteredAttendees.forEach(att => {
            const email = att.address || att.email
            if (!email) return;

            const apiMatch = apiAttendeesList.find(
                u => {
                    if (u.type === "User") {
                        if (linkby && u.id === linkby) {
                            return (
                                u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                                u.email?.toLowerCase() === email?.toLowerCase()
                            );
                        }
                        return (
                            u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                            u.email?.toLowerCase() === email?.toLowerCase()
                        );
                    }
                    return u.email?.toLowerCase() === email?.toLowerCase();
                });

            if (apiMatch && !includedEmails.has(email?.toLowerCase())) {
                attendeeData.push(apiMatch);
                includedEmails.add(email?.toLowerCase());
            }
        });
        if (configEmail && configEmail?.toLowerCase() !== hostEmail?.toLowerCase() && !includedEmails.has(configEmail?.toLowerCase()) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail?.toLowerCase(),
                email: configEmail?.toLowerCase(),
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function formatAttendees3(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();

        if (!Array.isArray(attendeeList)) return null;
        const filteredAttendees = attendeeList.filter(attendee => attendee.emailAddress.address?.toLowerCase() !== hostEmail?.toLowerCase());
        filteredAttendees.forEach(att => {
            const email = att.emailAddress.address || att.emailAddress.email
            if (!email) return;

            const apiMatch = apiAttendeesList.find(
                u => {
                    if (u.type === "User") {
                        if (linkby && u.id === linkby) {
                            return (
                                u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                                u.email?.toLowerCase() === email?.toLowerCase()
                            );
                        }
                        return (
                            u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                            u.email?.toLowerCase() === email?.toLowerCase()
                        );
                    }
                    return u.email?.toLowerCase() === email?.toLowerCase();
                });
            if (apiMatch && !includedEmails.has(email?.toLowerCase())) {
                attendeeData.push(apiMatch);
                includedEmails.add(email?.toLowerCase());
            }
        });
        if (configEmail && configEmail?.toLowerCase() !== hostEmail?.toLowerCase() && !includedEmails.has(configEmail?.toLowerCase()) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail?.toLowerCase(),
                email: configEmail?.toLowerCase(),
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function getOrganizerFrom(id, type, dataList) { // address
        const filtered = dataList.filter(item => item.type === type);
        // return filtered.find(item => item.id === id) || { name: address, email: address };
        return filtered.find(item => item.id === id) || { name: "Not Available", email: "Not Available" };
    }
    function getOrganizerFromEmail(email, type, dataList) {
        const filtered = dataList.filter(item => item.type === type);
        const user = filtered.find(u => u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() || u.email?.toLowerCase() === email?.toLowerCase());
        return user || { name: "Not Available", email: "Not Available" }
        // return filtered.find(item => item.email?.toLowerCase() === email?.toLowerCase()) ||
        //     { name: "Not Available", email: "Not Available" };
    }
    const getattendeeFrom = (type, fromEmail, dataList, linkedBy) => {
        const users = dataList.filter(item => item.type === type);
        let user = null;

        if (type === "User" && linkedBy) {
            user = users.find(u =>
                u.id === linkedBy &&
                u.emailConfigurationMail?.toLowerCase() === fromEmail?.toLowerCase()
            );
            if (!user) {
                user = users.find(u => u.id === linkedBy);
            }
        }
        // const user = users.find(u => {
        //     if (u.type === "User") {
        //         if (linkedBy && u.id === linkedBy) {
        //             return (
        //                 u.emailConfigurationMail?.toLowerCase() === fromEmail?.toLowerCase() ||
        //                 u.email?.toLowerCase() === fromEmail?.toLowerCase()
        //             );
        //         }
        //         return (
        //             u.emailConfigurationMail?.toLowerCase() === fromEmail?.toLowerCase() ||
        //             u.email?.toLowerCase() === fromEmail?.toLowerCase()
        //         );
        //     }
        //     return u.email?.toLowerCase() === fromEmail?.toLowerCase();
        // });
        const name = user?.name?.trim();
        const validData = name || fromEmail;
        return validData
    };
    // const getPerosnnDetails = (fromEmail, dataList) => {
    //     const user = dataList.find(
    //         u => {
    //             if (u.type === "User") {
    //                 return (
    //                     u.emailConfigurationMail?.toLowerCase() === fromEmail?.toLowerCase() ||
    //                     u.email?.toLowerCase() === fromEmail?.toLowerCase()
    //                 );
    //             }
    //             return u.email?.toLowerCase() === fromEmail?.toLowerCase();
    //         });

    //     const name = user?.name?.trim();
    //     const validData = name || fromEmail;
    //     return validData
    // };
    function formatAttendees4(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();
        const filteredAttendees = attendeeList.filter(att => att.address?.toLowerCase() !== hostEmail?.toLowerCase() && att.email?.toLowerCase() !== hostEmail?.toLowerCase());
        filteredAttendees.forEach(att => {
            const email = att.address || att.email;
            if (!email) return;

            const apiMatch = apiAttendeesList.find(
                u => {
                    if (u.type === "User") {
                        if (linkby && u.id === linkby) {
                            return (
                                u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                                u.email?.toLowerCase() === email?.toLowerCase()
                            );
                        }
                        return (
                            u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                            u.email?.toLowerCase() === email?.toLowerCase()
                        );
                    }
                    return u.email?.toLowerCase() === email?.toLowerCase();
                });

            if (apiMatch && !includedEmails.has(email?.toLowerCase())) {
                attendeeData.push(apiMatch);
                includedEmails.add(email?.toLowerCase());
            }
        });
        if (configEmail && configEmail?.toLowerCase() !== hostEmail?.toLowerCase() && !includedEmails.has(configEmail?.toLowerCase()) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail?.toLowerCase(),
                email: configEmail?.toLowerCase(),
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function findDataByEmail(email, leadData = [], contactData = []) {
        const leadMatchfound = leadData.find(item => item.primary_email?.toLowerCase() === email?.toLowerCase());
        if (leadMatchfound) {
            return {
                name: `${leadMatchfound?.first_name} ${leadMatchfound?.last_name}`,
                email: leadMatchfound?.primary_email?.toLowerCase(),
            };
        }
        const contactMatchfound = contactData.find(item => item.email?.toLowerCase() === email?.toLowerCase());
        if (contactMatchfound) {
            return {
                name: `${contactMatchfound?.first_name} ${contactMatchfound?.last_name}`,
                email: contactMatchfound?.email?.toLowerCase(),
            };
        }
        return {
            name: "Not Available",
            email: "Not Available"
        };
    }
    // function findDataByEmailR(email, leadData = [], contactData = []) {
    //     const leadMatchfound = leadData.find(item => item.primary_email?.toLowerCase() === email?.toLowerCase());
    //     if (leadMatchfound) {
    //         return `${leadMatchfound?.first_name} ${leadMatchfound?.last_name}`
    //     }
    //     const contactMatchfound = contactData.find(item => item.email?.toLowerCase() === email?.toLowerCase());
    //     if (contactMatchfound) {
    //         return `${contactMatchfound?.first_name} ${contactMatchfound?.last_name}`
    //     }
    //     return "Not Available"
    // }
    async function mailServerEmailData(mailServiceId) {
        const cleanString = (str) => str.trim()?.replace(/^["']|["']$/g, "");
        const parseEmail = (emailString) => {
            emailString = cleanString(emailString);
            const match = emailString.match(/(.*)<(.+)>/);
            if (match) {
                return {
                    name: cleanString(match[1]),
                    address: match[2].trim(),
                };
            }
            return {
                name: "",
                address: emailString,
            };
        };
        const normalizeField = (field) => {
            if (!field) return [];
            return field.split(",").map((item) => parseEmail(item.trim()));
            // return field.split(/[;,]/).map((item) => parseEmail(item.trim()));
        };
        if (mailServiceId) {
            try {
                const MailServerResponse = await findOneByMailService(mailServiceId)
                const formattedFrom = parseEmail(MailServerResponse?.from || "");
                const formattedTo = normalizeField(MailServerResponse?.to || "");
                return {
                    fromData: formattedFrom,
                    toData: formattedTo,
                };
            } catch (error) {
                const formattedFrom = parseEmail("");
                const formattedTo = normalizeField("");
                return {
                    fromData: formattedFrom,
                    toData: formattedTo,
                };
            }
        } else {
            const formattedFrom = parseEmail("");
            const formattedTo = normalizeField("");
            return {
                fromData: formattedFrom,
                toData: formattedTo,
            };
        }
    }
    async function FetchUserData(params) {
        try {
            const response = await FetchUserDetails(params)
            return response?.data
        }
        catch {
            return { firstName: "User" }
        }
    }
    const [expandedItems, setExpandedItems] = useState({});
    const toggleExpand = (index) => {
        setExpandedItems(prev => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    function getFormattedEventDateTime(node, profile, dateFormat, type, isEnd = false) {
        if (node?.dateTime) {
            return convertFromUTCAndFormatForDifferent(node.dateTime, profile, dateFormat, type);
        }
        if (node?.date) {
            let dateStr = node.date;
            if (isEnd) {
                const [y, m, d] = dateStr.split('-').map(Number);
                const utcDate = new Date(Date.UTC(y, m - 1, d));
                utcDate.setUTCDate(utcDate.getUTCDate() - 1);
                dateStr = utcDate.toISOString().slice(0, 10);
            }
            const syntheticDateTime = isEnd
                ? `${dateStr}T23:59:59`
                : `${dateStr}T00:00:00`;
            return convertFromUTCAndFormatForDifferent(syntheticDateTime, profile, dateFormat, type);
        }
        return "";
    }
    function normalizeGoogleEventDate(node, profile, isEnd = false) {
        if (node.dateTime) {
            const { date, time } = convertFromUTCAndFormat(node.dateTime, profile);
            return { date, time };
        }
        if (node.date) {
            let dateStr = node.date;
            if (isEnd) {
                const [y, m, d] = dateStr.split('-').map(Number);
                const utcDate = new Date(Date.UTC(y, m - 1, d));
                utcDate.setUTCDate(utcDate.getUTCDate() - 1);
                dateStr = utcDate.toISOString().slice(0, 10);
            }
            const syntheticDateTime = isEnd
                ? `${dateStr}T23:59:59`
                : `${dateStr}T00:00:00`;

            const { date, time } = convertFromUTCAndFormat(syntheticDateTime, profile);
            return { date, time };
        }
        return null;
    }
    async function formatMessage(message, item, index) {
        const isNumeric = (val) => /^\d+$/.test(val);
        const EmailSentByPattern = /Email\s*"(.*?)"\s*sent by\s*"(.*?)"/;
        const EmailReciveByPattern = /Email\s*"(.*?)"\s*received\s*from\s*"(.*?)"/;
        const MeetingSendByPattern = /Meeting\s*invite\s*"(.*?)"/;
        const taskAddedPattern = /Task\s*"(.*?)"\s*added\s*by\s*"(.*?)"/;
        const taskUpdatedPattern = /Task\s*"(.*?)"\s*updated\s*by\s*"(.*?)"/;
        const taskDeletePattern = /Tasks\s*"(.*?)"\s*Deleted\s*on\s*"(.*?)"/;
        const ownerChangePattern = /Owner\s*changed\s*from\s*"(.*)"\s*to\s*"(.*)"/;
        const CaseownerChangePattern = /Assignee\s*changed\s*from\s*"(.*)"\s*to\s*"(.*)"/;
        const noteAddedPattern = /Note\s*"(.*)"\s*added/;
        const callLogAddedPattern = /Call\s*log\s*"(.*)"\s*added/;
        if (taskAddedPattern.test(message)) {
            const [, , userName] = taskAddedPattern.exec(message);
            let newOwnerData;
            let OpenSet;
            if (isNumeric(userName)) {
                OpenSet = profile.userId !== Number(userName)
                newOwnerData = await FetchUserData(userName)
            } else {
                OpenSet = true
                newOwnerData = { firstName: userName }
            }
            return (
                <>
                    Task{" "}
                    {item.apiResponse?.childEntityData?.apiCall ? <Tooltip overlayClassName="ToolTip-Forcast"
                        title={
                            <div>
                                <div className='Right-side-divs'>
                                    <Text type="secondary" className='RightSide-Lable'>Owner</Text> <br />
                                    <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.taskOwner}</div>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 20 }}>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>Due Date</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }}>{formatDate(item?.apiResponse?.childEntityData?.Data?.due_date, profile)}</div>
                                    </div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>Status</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.status}</div>
                                    </div>
                                </div>
                                <div className='Right-side-divs'>
                                    <Text type="secondary" className='RightSide-Lable'>Assignee</Text> <br />
                                    <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.assignTofirstName} {item?.apiResponse?.childEntityData?.Data?.assignToLastName}</div>
                                </div>
                            </div>
                        }>
                        <span
                            className={item.apiResponse?.childEntityData?.Data?.allow ? "splTxtNavigate" : "splTxtHover"}
                            role="button"
                            tabIndex={0}
                            onClick={item.apiResponse?.childEntityData?.Data?.allow ? () =>
                                ViewTaskDetailPage("TASK", item.childEntityId, item.apiResponse?.childEntityData?.Data?.status, item.apiResponse?.childEntityData?.Data?.allow)
                                : undefined}
                            onKeyDown={(e) => {
                                if (item.apiResponse?.childEntityData?.Data?.allow && (e.key === "Enter" || e.key === " ")) {
                                    ViewTaskDetailPage("TASK", item.childEntityId, item.apiResponse?.childEntityData?.Data?.status, item.apiResponse?.childEntityData?.Data?.allow);
                                }
                            }}
                        >
                            {item.apiResponse?.childEntityData?.Data?.task_name}
                        </span>
                    </Tooltip> : <span className="splTxt">{item.apiResponse?.childEntityData?.Data?.task_name}</span>}{" "}
                    added by{" "}
                    {OpenSet ?
                        <Tooltip overlayClassName="ToolTip-Forcast" title={<div style={{ width: "240px" }}>
                            <UserCenterCard1 item={newOwnerData} />
                        </div>}>
                            <span className="splTxtUser">{newOwnerData?.firstName} {newOwnerData?.lastName}</span>
                        </Tooltip> : <span className="splTxt">{newOwnerData?.firstName} {newOwnerData?.lastName}</span>}
                </>
            );
        }
        if (taskUpdatedPattern.test(message)) {
            const [, , userName] = taskUpdatedPattern.exec(message);
            let newOwnerData;
            let OpenSet;
            if (isNumeric(userName)) {
                OpenSet = profile.userId !== Number(userName)
                newOwnerData = await FetchUserData(userName)
            } else {
                OpenSet = true
                newOwnerData = { firstName: userName }
            }
            return (
                <>
                    Task{" "}
                    {item.apiResponse?.childEntityData?.apiCall ? <Tooltip overlayClassName="ToolTip-Forcast"
                        title={
                            <div>
                                <div className='Right-side-divs'>
                                    <Text type="secondary" className='RightSide-Lable'>Owner</Text> <br />
                                    <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.taskOwner}</div>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 20 }}>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>Due Date</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }}>{formatDate(item?.apiResponse?.childEntityData?.Data?.due_date, profile)}</div>
                                    </div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>Status</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.status}</div>
                                    </div>
                                </div>
                                <div className='Right-side-divs'>
                                    <Text type="secondary" className='RightSide-Lable'>Assignee</Text> <br />
                                    <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.assignTofirstName} {item?.apiResponse?.childEntityData?.Data?.assignToLastName}</div>
                                </div>
                            </div>
                        }>
                        <span
                            className={item.apiResponse?.childEntityData?.Data?.allow ? "splTxtNavigate" : "splTxtHover"}
                            role="button"
                            tabIndex={0}
                            onClick={item.apiResponse?.childEntityData?.Data?.allow ? () =>
                                ViewTaskDetailPage("TASK", item.childEntityId, item.apiResponse?.childEntityData?.Data?.status, item.apiResponse?.childEntityData?.Data?.allow)
                                : undefined}
                            onKeyDown={(e) => {
                                if (item.apiResponse?.childEntityData?.Data?.allow && (e.key === "Enter" || e.key === " ")) {
                                    ViewTaskDetailPage("TASK", item.childEntityId, item.apiResponse?.childEntityData?.Data?.status, item.apiResponse?.childEntityData?.Data?.allow);
                                }
                            }}
                        >
                            {item.apiResponse?.childEntityData?.Data?.task_name}
                        </span>
                    </Tooltip> : <span className="splTxt">{item.apiResponse?.childEntityData?.Data?.task_name}</span>}{" "}
                    updated by{" "}
                    {OpenSet ? <Tooltip overlayClassName="ToolTip-Forcast" title={<div style={{ width: "240px" }}>
                        <UserCenterCard1 item={newOwnerData} />
                    </div>}>
                        <span className="splTxtUser">{newOwnerData?.firstName} {newOwnerData?.lastName}</span>
                    </Tooltip> : <span className="splTxt">{newOwnerData?.firstName} {newOwnerData?.lastName}</span>}
                </>
            );
        }
        if (taskDeletePattern.test(message)) {
            const [, , date] = taskDeletePattern.exec(message);
            return (
                <>
                    Task{" "}
                    {item.apiResponse?.childEntityData?.apiCall ? <Tooltip overlayClassName="ToolTip-Forcast"
                        title={
                            <div>
                                <div className='Right-side-divs'>
                                    <Text type="secondary" className='RightSide-Lable'>Owner</Text> <br />
                                    <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.taskOwner}</div>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 20 }}>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>Due Date</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }}>{formatDate(item?.apiResponse?.childEntityData?.Data?.due_date, profile)}</div>
                                    </div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>Status</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.status}</div>
                                    </div>
                                </div>
                                <div className='Right-side-divs'>
                                    <Text type="secondary" className='RightSide-Lable'>Assignee</Text> <br />
                                    <div style={{ color: "black", fontSize: 12 }}>{item?.apiResponse?.childEntityData?.Data?.assignTofirstName} {item?.apiResponse?.childEntityData?.Data?.assignToLastName}</div>
                                </div>
                            </div>
                        }>
                        <span
                            className={item.apiResponse?.childEntityData?.Data?.allow ? "splTxtNavigate" : "splTxtHover"}
                            role="button"
                            tabIndex={0}
                            onClick={item.apiResponse?.childEntityData?.Data?.allow ? () =>
                                ViewTaskDetailPage("TASK", item.childEntityId, item.apiResponse?.childEntityData?.Data?.status, item.apiResponse?.childEntityData?.Data?.allow)
                                : undefined}
                            onKeyDown={(e) => {
                                if (item.apiResponse?.childEntityData?.Data?.allow && (e.key === "Enter" || e.key === " ")) {
                                    ViewTaskDetailPage("TASK", item.childEntityId, item.apiResponse?.childEntityData?.Data?.status, item.apiResponse?.childEntityData?.Data?.allow);
                                }
                            }}
                        >
                            {item.apiResponse?.childEntityData?.Data?.task_name}
                        </span>
                    </Tooltip> : <span className="splTxt">{item.apiResponse?.childEntityData?.Data?.task_name}</span>}{" "}
                    Deleted on{" "}
                    {/* <Tooltip title={`User Details for ${userName}`}> */}
                    <span className="splTxtUser">{formatDate(date, profile)}</span>
                    {/* </Tooltip> */}
                </>
            );
        }
        if (ownerChangePattern.test(message)) {
            const [, oldOwner, newOwner] = ownerChangePattern.exec(message);
            const isNumeric = (val) => /^\d+$/.test(val);
            let oldOwnerData;
            let OpenSet;
            let newOwnerData;
            let OpenSet1;
            if (isNumeric(oldOwner)) {
                oldOwnerData = await FetchUserData(oldOwner)
                OpenSet = profile.userId !== Number(oldOwner)
            } else {
                oldOwnerData = { firstName: oldOwner }
                OpenSet = true
            }

            if (isNumeric(newOwner)) {
                newOwnerData = await FetchUserData(newOwner)
                OpenSet1 = profile.userId !== Number(newOwner)
            } else {
                newOwnerData = { firstName: newOwner }
                OpenSet1 = true
            }
            return (
                <>
                    Owner changed from{" "}
                    {OpenSet ? <Tooltip overlayClassName="ToolTip-Forcast" title={<div style={{ width: "240px" }}>
                        <UserCenterCard1 item={oldOwnerData} />
                    </div>}>
                        <span className="splTxtUser">{oldOwnerData?.firstName} {oldOwnerData?.lastName}</span>
                    </Tooltip> : <span className="splTxt">{oldOwnerData?.firstName} {oldOwnerData?.lastName}</span>}{" "}to{" "}
                    {OpenSet1 ? <Tooltip overlayClassName="ToolTip-Forcast" title={<div style={{ width: "240px" }}>
                        <UserCenterCard1 item={newOwnerData} />
                    </div>}>
                        <span className="splTxtUser">{newOwnerData?.firstName} {newOwnerData?.lastName}</span>
                    </Tooltip> : <span className="splTxt">{newOwnerData?.firstName} {newOwnerData?.lastName}</span>}{" "}
                </>
            );
        }
        if (CaseownerChangePattern.test(message)) {
            const [, oldOwner, newOwner] = CaseownerChangePattern.exec(message);
            const isNumeric = (val) => /^\d+$/.test(val);
            let oldOwnerData;
            let OpenSet;
            let newOwnerData;
            let OpenSet1;
            if (isNumeric(oldOwner)) {
                oldOwnerData = await FetchUserData(oldOwner)
                OpenSet = profile.userId !== Number(oldOwner)
            } else {
                oldOwnerData = { firstName: oldOwner }
                OpenSet = true
            }

            if (isNumeric(newOwner)) {
                newOwnerData = await FetchUserData(newOwner)
                OpenSet1 = profile.userId !== Number(newOwner)
            } else {
                newOwnerData = { firstName: newOwner }
                OpenSet1 = true
            }
            return (
                <>
                    Assignee changed from{" "}
                    {OpenSet ? <Tooltip overlayClassName="ToolTip-Forcast" title={<div style={{ width: "240px" }}>
                        <UserCenterCard1 item={oldOwnerData} />
                    </div>}>
                        <span className="splTxtUser">{oldOwnerData?.firstName} {oldOwnerData?.lastName}</span>
                    </Tooltip> : <span className="splTxt">{oldOwnerData?.firstName} {oldOwnerData?.lastName}</span>}{" "}to{" "}
                    {OpenSet1 ? <Tooltip overlayClassName="ToolTip-Forcast" title={<div style={{ width: "240px" }}>
                        <UserCenterCard1 item={newOwnerData} />
                    </div>}>
                        <span className="splTxtUser">{newOwnerData?.firstName} {newOwnerData?.lastName}</span>
                    </Tooltip> : <span className="splTxt">{newOwnerData?.firstName} {newOwnerData?.lastName}</span>}{" "}
                </>
            );
        }
        if (noteAddedPattern.test(message)) {
            // const [, name] = noteAddedPattern.exec(message);
            return (
                <>
                    Note{" "}
                    <span
                        className={item.apiResponse?.childEntityData?.apiCall ? "splTxtNavigate" : "splTxt"}
                        role="button"
                        tabIndex={0}
                        onClick={item.apiResponse?.childEntityData?.apiCall ? () => ViewNotePopup(item.childEntityId, item.apiResponse?.childEntityData?.Data?.status) : undefined}
                        onKeyDown={(e) => {
                            if (item.apiResponse?.childEntityData?.apiCall && (e.key === 'Enter' || e.key === ' ')) {
                                ViewNotePopup(item.childEntityId, item.apiResponse?.childEntityData?.Data?.status)
                            }
                        }}
                    >
                        {item.apiResponse?.childEntityData?.Data?.noteTittle}
                    </span>{" "}added
                </>
            );
        }
        if (callLogAddedPattern.test(message)) {
            // const [, name] = callLogAddedPattern.exec(message);
            return (
                <>
                    Call log{" "}
                    <span
                        className={item.apiResponse?.childEntityData?.apiCall ? "splTxtNavigate" : "splTxt"}
                        role="button"
                        tabIndex={0}
                        onClick={item.apiResponse?.childEntityData?.apiCall ? () => ViewCallLogPopup(item.childEntityId, item.apiResponse?.childEntityData?.Data?.status) : undefined}
                        onKeyDown={(e) => {
                            if (item.apiResponse?.childEntityData?.apiCall && (e.key === 'Enter' || e.key === ' ')) {
                                ViewCallLogPopup(item.childEntityId, item.apiResponse?.childEntityData?.Data?.status)
                            }
                        }}>
                        {item.apiResponse?.childEntityData?.Data?.CallTitle}
                    </span>{" "}added
                </>
            );
        }
        if (EmailSentByPattern.test(message)) {
            const [, taskName, userName] = EmailSentByPattern.exec(message);
            const { fromData, toData } = await mailServerEmailData(item?.emailData?.mailServiceId)
            const fromDataEmail = item?.emailData ? fromData?.address : userName
            const emailTypeFind = item?.emailData ? item?.emailData?.actionType : item?.action
            let FromAddress;
            if (emailTypeFind === "Sent") {
                FromAddress =
                    // (emailactiontype?.email?.toLowerCase() === fromDataEmail?.toLowerCase()) ?
                    //     `${profile?.firstName} ${profile?.lastName}` : 
                    getattendeeFrom("User", fromDataEmail, allattendeeData, item?.emailData?.linkedBy)
            }
            if (emailTypeFind === "Recived") {
                if (item?.emailData?.entityType === "Lead" || item?.emailData?.entityType === "Contact") {
                    const origanizerdata = getOrganizerFrom(item?.emailData?.entityId, `${item?.emailData?.entityType}s`, allattendeeData, fromDataEmail)
                    FromAddress = origanizerdata?.name || origanizerdata?.email
                }
                else if (item?.emailData?.entityType === "Case") {
                    const origanizerdata = findDataByEmail(fromDataEmail, allLeadList, allContactList)
                    FromAddress = origanizerdata?.name || origanizerdata?.email
                }
                else {
                    const origanizerdata = getOrganizerFromEmail(fromDataEmail, "Contacts", allattendeeData)
                    FromAddress = origanizerdata?.name || origanizerdata?.email
                }
            }
            const ToAddress = formatAttendees4(toData, fromDataEmail, emailactiontype?.email, allattendeeData, item?.emailData?.linkedBy);
            // const emailPerson = (emailactiontype?.email?.toLowerCase() === userName?.toLowerCase()) ? `${profile?.firstName} ${profile?.lastName}` : getPerosnnDetails(userName, allattendeeData)
            return (
                <>
                    Email{" "}
                    {item?.emailData && item?.emailData !== "" ?
                        <Tooltip overlayClassName="ToolTip-Forcast"
                            title={
                                <div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>From</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }} className='div-ellipsis' title={FromAddress}>{FromAddress}</div>
                                    </div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>Date</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }}>{convertAndFormatDateTime(item?.emailData?.actionDate, companyProfile, profile)}</div>
                                    </div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>To</Text> <br />
                                        {ToAddress?.length > 0 ?
                                            <>
                                                {(expandedItems[index] ? ToAddress : ToAddress.slice(0, 3)).map((attendee, i, arr) => (
                                                    <span
                                                        key={i}
                                                        title={attendee.name?.trim() || attendee.email}
                                                        style={{ color: 'black', fontSize: 12 }}
                                                    >
                                                        {attendee.name?.trim() || attendee.email}
                                                        {/* {i < (expandedItems[index] ? ToAddress.length : 3) - 1 && ', '} */}
                                                        {i < arr.length - 1 && ', '}
                                                    </span>
                                                ))}

                                                {ToAddress.length > 3 && (
                                                    <span
                                                        role="button"
                                                        tabIndex={0}
                                                        style={{ color: "#1890ff", cursor: "pointer", marginLeft: 4 }}
                                                        onClick={() => toggleExpand(index)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === " ") {
                                                                toggleExpand(index);
                                                            }
                                                        }}
                                                    >
                                                        {expandedItems[index] ? 'show less' : '...more'}
                                                    </span>
                                                )}
                                            </>
                                            : <span style={{ color: 'black', fontSize: 12 }}>Not Available</span>}
                                    </div>
                                </div>
                            }>
                            <span
                                className="splTxtNavigate"
                                role="button"
                                tabIndex={0}
                                onClick={() =>
                                    ViewDetailPage(item?.emailData?.sourceId, item?.emailData?.actionType === "Recived" ? "INBOX" : item?.emailData?.actionType === "Sent" ? "Sent" : "", item?.emailData?.linkedBy, item?.emailData?.mailServer, item?.emailData?.serverEmail)
                                }
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        ViewDetailPage(item?.emailData?.sourceId, item?.emailData?.actionType === "Recived" ? "INBOX" : item?.emailData?.actionType === "Sent" ? "Sent" : "", item?.emailData?.linkedBy, item?.emailData?.mailServer, item?.emailData?.serverEmail)
                                    }
                                }}
                            >
                                {taskName}
                            </span>
                        </Tooltip> : <span className="splTxt">{taskName}</span>}{" "}
                    sent by{" "}
                    {/* <Tooltip title={`User Details for ${userName}`}> */}
                    <span className="splTxt">{FromAddress}</span>
                    {/* </Tooltip> */}
                </>
            );
        }
        if (EmailReciveByPattern.test(message)) {
            const [, taskName, userName] = EmailReciveByPattern.exec(message);
            const { fromData, toData } = await mailServerEmailData(item?.emailData?.mailServiceId)
            const fromDataEmail = item?.emailData ? fromData?.address : userName
            const emailTypeFind = item?.emailData ? item?.emailData?.actionType : item?.action
            let FromAddress;
            if (emailTypeFind === "Sent") {
                FromAddress =
                    //  (emailactiontype?.email?.toLowerCase() === fromDataEmail?.toLowerCase()) ?
                    //     `${profile?.firstName} ${profile?.lastName}` : 
                    getattendeeFrom("User", fromDataEmail, allattendeeData, item?.emailData?.linkedBy)
            }
            if (emailTypeFind === "Recived") {
                if (item?.emailData?.entityType === "Lead" || item?.emailData?.entityType === "Contact") {
                    const origanizerdata = getOrganizerFrom(item?.emailData?.entityId, `${item?.emailData?.entityType}s`, allattendeeData, fromDataEmail)
                    FromAddress = origanizerdata?.name || origanizerdata?.email
                }
                else if (item?.emailData?.entityType === "Case") {
                    const origanizerdata = findDataByEmail(fromDataEmail, allLeadList, allContactList)
                    FromAddress = origanizerdata?.name || origanizerdata?.email
                }
                else {
                    const origanizerdata = getOrganizerFromEmail(fromDataEmail, "Contacts", allattendeeData)
                    FromAddress = origanizerdata?.name || origanizerdata?.email
                }
            }
            const ToAddress = formatAttendees4(toData, fromDataEmail, emailactiontype?.email, allattendeeData, item?.emailData?.linkedBy);
            // const emailPerson = (emailactiontype?.email?.toLowerCase() === userName?.toLowerCase()) ? `${profile?.firstName} ${profile?.lastName}` :
            //     item?.emailData?.entityType === "Case" ? findDataByEmailR(userName, allLeadList, allContactList) : getPerosnnDetails(userName, allattendeeData)
            return (
                <>
                    Email{" "}
                    {item?.emailData && item?.emailData !== "" ?
                        <Tooltip overlayClassName="ToolTip-Forcast"
                            title={
                                <div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>From</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }} className='div-ellipsis' title={FromAddress}>{FromAddress}</div>
                                    </div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>Date</Text> <br />
                                        <div style={{ color: "black", fontSize: 12 }}>{convertAndFormatDateTime(item?.emailData?.actionDate, companyProfile, profile)}</div>
                                    </div>
                                    <div className='Right-side-divs'>
                                        <Text type="secondary" className='RightSide-Lable'>To</Text> <br />
                                        {ToAddress?.length > 0 ?
                                            <>
                                                {(expandedItems[index] ? ToAddress : ToAddress.slice(0, 3)).map((attendee, i, arr) => (
                                                    <span
                                                        key={i}
                                                        title={attendee.name?.trim() || attendee.email}
                                                        style={{ color: 'black', fontSize: 12 }}
                                                    >
                                                        {attendee.name?.trim() || attendee.email}
                                                        {/* {i < (expandedItems[index] ? ToAddress.length : 3) - 1 && ', '} */}
                                                        {i < arr.length - 1 && ', '}
                                                    </span>
                                                ))}

                                                {ToAddress.length > 3 && (
                                                    <span
                                                        role="button"
                                                        tabIndex={0}
                                                        style={{ color: "#1890ff", cursor: "pointer", marginLeft: 4 }}
                                                        onClick={() => toggleExpand(index)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === " ") {
                                                                toggleExpand(index);
                                                            }
                                                        }}
                                                    >
                                                        {expandedItems[index] ? 'show less' : '...more'}
                                                    </span>
                                                )}
                                            </>
                                            : <span style={{ color: 'black', fontSize: 12 }}>Not Available</span>}
                                    </div>
                                </div>
                            }>
                            <span
                                className="splTxtNavigate"
                                role="button"
                                tabIndex={0}
                                onClick={() =>
                                    ViewDetailPage(item?.emailData?.sourceId, item?.emailData?.actionType === "Recived" ? "INBOX" : item?.emailData?.actionType === "Sent" ? "Sent" : "", item?.emailData?.linkedBy, item?.emailData?.mailServer, item?.emailData?.serverEmail)
                                }
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        ViewDetailPage(item?.emailData?.sourceId, item?.emailData?.actionType === "Recived" ? "INBOX" : item?.emailData?.actionType === "Sent" ? "Sent" : "", item?.emailData?.linkedBy, item?.emailData?.mailServer, item?.emailData?.serverEmail)
                                    }
                                }}
                            >
                                {taskName}
                            </span>
                        </Tooltip> : <span className="splTxt">{taskName}</span>}{" "}
                    received from{" "}
                    {/* <Tooltip title={`User Details for ${userName}`}> */}
                    <span className="splTxt">{FromAddress}</span>
                    {/* </Tooltip> */}
                </>
            );
        }
        if (item?.childEntity === "Meeting") {
            if (MeetingSendByPattern.test(message)) {
                const [, taskName] = MeetingSendByPattern.exec(message);
                let formattedFromDate;
                let formattedFromTime;
                let StartDateTimeDif;
                let EndDateTimeDif;
                let FromAddress;
                let ToAddress;
                if (item?.meetingData?.configurationType === "Google") {
                    if (item?.meetingData?.actionType === "organizer") {
                        if (item?.meetingData?.entityType === "Lead" || item?.meetingData?.entityType === "Contact") {
                            const origanizerdata = getOrganizerFrom(item?.meetingData?.entityId, `${item?.meetingData?.entityType}s`, allattendeeData)
                            FromAddress = origanizerdata?.name || origanizerdata?.email
                        }
                        else {
                            const origanizerdata = item?.meetingData?.meetingDetail ? getOrganizerFromEmail(item?.meetingData?.meetingDetail?.organizer.email, "Contacts", allattendeeData) : { name: item?.meetingData?.meetingDetail?.organizer.email, email: item?.meetingData?.meetingDetail?.organizer.email }
                            FromAddress = origanizerdata?.name || origanizerdata?.email
                        }
                    }
                    if (item?.meetingData?.actionType === "attendee") {
                        FromAddress =
                            // (emailapiValues?.email?.toLowerCase() === item?.meetingData?.meetingDetail?.organizer?.email?.toLowerCase()) ?
                            //     `${profile?.firstName} ${profile?.lastName}` : 
                            getattendeeFrom("User", item?.meetingData?.meetingDetail?.organizer?.email, allattendeeData, item?.meetingData?.linkedBy)
                    }
                    const attendeeString = formatAttendees(item?.meetingData?.meetingDetail?.attendees, item?.meetingData?.meetingDetail?.organizer?.email, emailapiValues?.email, allattendeeData, item?.meetingData?.linkedBy);
                    ToAddress = attendeeString
                    const sDateTime = getFormattedEventDateTime(item?.meetingData?.dateAndTime?.start, profile, "MM/DD/YYYY", "0")
                    const EDateTime = getFormattedEventDateTime(item?.meetingData?.dateAndTime?.end, profile, "MM/DD/YYYY", "0")
                    const startTimeDate = normalizeGoogleEventDate(item?.meetingData?.dateAndTime?.start, profile)
                    StartDateTimeDif = sDateTime
                    EndDateTimeDif = EDateTime
                    formattedFromDate = startTimeDate.date
                    formattedFromTime = startTimeDate.time
                }
                else if (item?.meetingData?.configurationType === "Outlook") {
                    if (item?.meetingData?.actionType === "organizer") {
                        if (item?.meetingData?.entityType === "Lead" || item?.meetingData?.entityType === "Contact") {
                            const origanizerdata = getOrganizerFrom(item?.meetingData?.entityId, `${item?.meetingData?.entityType}s`, allattendeeData)
                            FromAddress = origanizerdata.name || origanizerdata.email
                        }
                        else {
                            const origanizerdata = item?.meetingData?.meetingDetail ? getOrganizerFromEmail(item?.meetingData?.meetingDetail?.organizer?.emailAddress?.address, "Contacts", allattendeeData) : { name: item?.meetingData?.meetingDetail?.organizer?.emailAddress?.address, email: item?.meetingData?.meetingDetail?.organizer?.emailAddress?.address }
                            FromAddress = origanizerdata.name || origanizerdata.email
                        }
                    }
                    if (item?.meetingData?.actionType === "attendee") {
                        FromAddress =
                            // (emailapiValues?.email?.toLowerCase() === item?.meetingData?.meetingDetail?.organizer?.emailAddress?.address?.toLowerCase()) ?
                            //     `${profile?.firstName} ${profile?.lastName}` :
                            getattendeeFrom("User", item?.meetingData?.meetingDetail?.organizer?.emailAddress?.address, allattendeeData, item?.meetingData?.linkedBy)
                        // ((meetingDetail?.organizer?.emailAddress?.name && meetingDetail?.organizer?.emailAddress?.name !== "") ?meetingDetail?.organizer?.emailAddress?.name : meetingDetail?.organizer?.emailAddress?.address)
                    }
                    const attendeeString = formatAttendees3(item?.meetingData?.meetingDetail?.attendees, item?.meetingData?.meetingDetail?.organizer?.emailAddress?.address, emailapiValues?.email, allattendeeData, item?.meetingData?.linkedBy);
                    ToAddress = attendeeString
                    const startFrom = OutLookDateTimeForTimeZone(item?.meetingData?.dateAndTime?.start?.dateTime)
                    const endTo = OutLookDateTimeForTimeZone(item?.meetingData?.dateAndTime?.end?.dateTime)
                    const sDateTime = convertFromUTCAndFormatForDifferent1(startFrom, profile, "MM/DD/YYYY", "0")
                    const EDateTime = convertFromUTCAndFormatForDifferent1(endTo, profile, "MM/DD/YYYY", "0")
                    const startTimeDate = convertFromUTCAndFormat1(startFrom, profile)
                    StartDateTimeDif = sDateTime
                    EndDateTimeDif = EDateTime
                    formattedFromDate = startTimeDate.date
                    formattedFromTime = startTimeDate.time
                }
                else if (item?.meetingData?.configurationType === "Zoho") {
                    if (item?.meetingData?.actionType === "organizer") {
                        if (item?.meetingData?.entityType === "Lead" || item?.meetingData?.entityType === "Contact") {
                            const origanizerdata = getOrganizerFrom(item?.meetingData?.entityId, `${item?.meetingData?.entityType}s`, allattendeeData)
                            FromAddress = origanizerdata.name || origanizerdata.email
                        }
                        else {
                            const origanizerdata = item?.meetingData?.meetingDetail ? getOrganizerFromEmail(item?.meetingData?.meetingDetail?.organizer, "Contacts", allattendeeData) : { name: item?.meetingData?.meetingDetail?.organizer, email: item?.meetingData?.meetingDetail?.organizer }
                            FromAddress = origanizerdata.name || origanizerdata.email
                        }
                    }
                    if (item?.meetingData?.actionType === "attendee") {
                        FromAddress =
                            // (emailapiValues?.email?.toLowerCase() === item?.meetingData?.meetingDetail?.organizer?.toLowerCase()) ?
                            //     `${profile?.firstName} ${profile?.lastName}` :
                            getattendeeFrom("User", item?.meetingData?.meetingDetail?.organizer, allattendeeData, item?.meetingData?.linkedBy)
                    }
                    const attendeeString = formatAttendees2(item?.meetingData?.meetingDetail?.attendees, item?.meetingData?.meetingDetail?.organizer, emailapiValues?.email, allattendeeData, item?.meetingData?.linkedBy);
                    ToAddress = attendeeString
                    const startFrom = ZohoDateTimeForTimeZone(item?.meetingData?.dateAndTime?.start)
                    const endTo = ZohoDateTimeForTimeZone(item?.meetingData?.dateAndTime?.end)
                    const sDateTime = convertFromUTCAndFormatForDifferent1(startFrom, profile, "MM/DD/YYYY", "0")
                    const EDateTime = convertFromUTCAndFormatForDifferent1(endTo, profile, "MM/DD/YYYY", "0")
                    const startTimeDate = convertFromUTCAndFormat1(startFrom, profile)
                    StartDateTimeDif = sDateTime
                    EndDateTimeDif = EDateTime
                    formattedFromDate = startTimeDate.date
                    formattedFromTime = startTimeDate.time
                }
                const FullTime = formatTimeDifference(StartDateTimeDif, EndDateTimeDif)
                return (
                    <>
                        Meeting invite{" "}
                        {item?.meetingData && item?.meetingData !== "" ?
                            <Tooltip overlayClassName="ToolTip-Forcast"
                                title={
                                    <div>
                                        <div className='Right-side-divs'>
                                            <Text type="secondary" className='RightSide-Lable'>From</Text> <br />
                                            <div style={{ color: "black", fontSize: 12 }} className='div-ellipsis' title={FromAddress}>{FromAddress}</div>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 15 }}>
                                            <div className='Right-side-divs'>
                                                <Text type="secondary" className='RightSide-Lable'>Meeting Date</Text> <br />
                                                <div style={{ color: "black", fontSize: 12 }}>{formattedFromDate}</div>
                                            </div><div className='Right-side-divs'>
                                                <Text type="secondary" className='RightSide-Lable'>Meeting Time</Text> <br />
                                                <div style={{ color: "black", fontSize: 12 }}>{formattedFromTime}, {FullTime}</div>
                                            </div>
                                        </div>
                                        <div className='Right-side-divs'>
                                            <Text type="secondary" className='RightSide-Lable'>To</Text> <br />
                                            {ToAddress?.length > 0 ? (
                                                <>
                                                    {(expandedItems[index] ? ToAddress : ToAddress.slice(0, 3)).map((attendee, i, arr) => (
                                                        <span
                                                            key={i}
                                                            title={attendee.name?.trim() || attendee.email}
                                                            style={{ color: 'black', fontSize: 12 }}
                                                        >
                                                            {attendee.name?.trim() || attendee.email}
                                                            {/* {i < (expandedItems[index] ? ToAddress.length : 3) - 1 && ', '} */}
                                                            {i < arr.length - 1 && ', '}
                                                        </span>
                                                    ))}

                                                    {ToAddress.length > 3 && (
                                                        <span
                                                            role="button"
                                                            tabIndex={0}
                                                            style={{ color: "#1890ff", cursor: "pointer", marginLeft: 4 }}
                                                            onClick={() => toggleExpand(index)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    toggleExpand(index);
                                                                }
                                                            }}
                                                        >
                                                            {expandedItems[index] ? 'show less' : '...more'}
                                                        </span>
                                                    )}
                                                </>
                                            ) : <span style={{ color: 'black', fontSize: 12 }}>Not Available</span>}
                                        </div>
                                    </div>
                                }>
                                <span
                                    className="splTxtNavigate"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() =>
                                        ViewDetailPage2(item?.meetingData?.sourceId, item?.meetingData?.linkedBy, item?.meetingData?.configurationType, item?.meetingData?.serverEmail)
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            ViewDetailPage2(item?.meetingData?.sourceId, item?.meetingData?.linkedBy, item?.meetingData?.configurationType, item?.meetingData?.serverEmail)
                                        }
                                    }}
                                >
                                    {taskName}
                                </span>
                            </Tooltip> : <span className="splTxt">{taskName}</span>}{" "}
                        {item?.meetingData ? <>
                            {item?.action === "organizer" ? "received from" : item?.action === "attendee" ? "sent by" : ""}{" "}
                            <span className="splTxt">{FromAddress}</span></> :
                            <>{item?.action === "organizer" ? "received" : item?.action === "attendee" ? "sent" : ""}{" "}</>
                        }
                    </>
                );
            }
        }
        const quoteRegex = /"([^"]*)"/g;
        const formattedMessage = message?.replace(quoteRegex, (match, quotedText) => {
            return `<span class="splTxt">${quotedText}</span>`;
        });
        /* eslint-disable react/no-danger */
        return <span dangerouslySetInnerHTML={{ __html: formattedMessage }} />;
        /* eslint-enable react/no-danger */
    }
    async function highlightValuesInsideQuotes(message) {
        const ConvertRates = defaultCurrency?.exchangeRate;
        const Currency = defaultCurrency?.symbol;
        const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;

        // Regex patterns for both types of messages
        const newDealRegex = /Deal\s*value\s*of\s*"([\d.]+)"/;
        const updatedDealRegex = /Deal\s*value\s*updated\s*from\s*"([\d.]+)"\s*to\s*"([\d.]+)"/;
        const dateUpdatedRegex = /((Expected\s*deal\s*closure\s*date|Revenue\s*start\s*date|Revenue\s*end\s*date))\s*updated\s*from\s*"([^"]+)"\s*to\s*"([^"]+)"/;
        const dateAddedRegex = /((Expected\s*deal\s*closure\s*date|Revenue\s*start\s*date|Revenue\s*end\s*date))\s*of\s*"([^"]+)"\s*added/;
        const dealDiscountAddedRegex = /Deal\s*discount\s*of\s*"([\d.]+)"\s*added/;
        const dealDiscountUpdatedRegex = /Deal\s*discount\s*updated\s*from\s*"([\d.]+)"\s*to\s*"([\d.]+)"/;
        const dealwinProbUpdatedRegex = /Deal\s*win\s*probability\s*updated\s*to\s*"([\d.]+)"/;

        let formattedMessage = message;

        // Check for updated deal value message
        const updatedMatch = message.match(updatedDealRegex);
        if (updatedMatch) {
            const [, oldVal, newVal] = updatedMatch;
            const formattedOld = await ExchangeCurrency(Number(oldVal), ConvertRates);
            const formattedNew = await ExchangeCurrency(Number(newVal), ConvertRates);
            const fOld = Number(formattedOld?.toFixed(CurencyDecimalPlace));
            const fNew = Number(formattedNew?.toFixed(CurencyDecimalPlace));

            formattedMessage = message?.replace(
                updatedDealRegex,
                `Deal value updated from "${Currency} ${fOld.toLocaleString()}" to "${Currency} ${fNew.toLocaleString()}"`
            );
        } else {
            // Check for new deal value message
            const newMatch = message.match(newDealRegex);
            if (newMatch) {
                const [, val] = newMatch;
                const formattedVal = await ExchangeCurrency(Number(val), ConvertRates);
                const fVal = Number(formattedVal?.toFixed(CurencyDecimalPlace));

                formattedMessage = message?.replace(
                    newDealRegex,
                    `Deal value of "${Currency} ${fVal.toLocaleString()}"`
                );
            }
        }
        const updatedDateMatch = formattedMessage.match(dateUpdatedRegex);
        if (updatedDateMatch) {
            const [, , label, oldDate, newDate] = updatedDateMatch;
            const formattedOldDate = formatDate(oldDate, profile);
            const formattedNewDate = formatDate(newDate, profile);
            formattedMessage = formattedMessage?.replace(
                dateUpdatedRegex,
                `${label} updated from "${formattedOldDate}" to "${formattedNewDate}"`
            );
        } else {
            // Format added date message
            const addedDateMatch = formattedMessage.match(dateAddedRegex);
            if (addedDateMatch) {
                const [, , label, date] = addedDateMatch;
                const formattedDate = formatDate(date, profile);
                formattedMessage = formattedMessage?.replace(
                    dateAddedRegex,
                    `${label} of "${formattedDate}" added`
                );
            }
        }
        // Format updated deal discount (adds %)
        const discountUpdatedMatch = formattedMessage.match(dealDiscountUpdatedRegex);
        const dealwinProbUpdatedRegexMatch = formattedMessage.match(dealwinProbUpdatedRegex);
        if (discountUpdatedMatch) {
            const [, oldDiscount, newDiscount] = discountUpdatedMatch;
            formattedMessage = formattedMessage?.replace(
                dealDiscountUpdatedRegex,
                `Deal discount updated from "${Number(oldDiscount)}%" to "${Number(newDiscount)}%"`
            );
        } else {
            const discountAddedMatch = formattedMessage.match(dealDiscountAddedRegex);
            if (discountAddedMatch) {
                const [, discount] = discountAddedMatch;
                formattedMessage = formattedMessage?.replace(
                    dealDiscountAddedRegex,
                    `Deal discount of "${Number(discount)}%" added`
                );
            }
        }
        if (dealwinProbUpdatedRegexMatch) {
            const [, discount] = dealwinProbUpdatedRegexMatch;
            formattedMessage = formattedMessage?.replace(
                dealwinProbUpdatedRegex,
                `Deal win probability updated to "${Number(discount)}%"`
            );
        }
        return formattedMessage;
    }
    async function fetchCombinedEntityData(childEntity, childEntityId) { // , entity, entityId
        // const entityData = await fetchEntityData(entity, entityId);
        try {
            const childEntityData = await fetchChildEntityData(childEntity, childEntityId);
            const apiResponse = {
                // ...entityData,
                childEntityData,
            };
            return apiResponse;
        }
        catch (error) {
            return { error: true };
        }
    }
    async function RecentActivity2() {
        try {
            const data = await getAllActivityByType1(apiType, UrlId[1]);
            const filterVisibleData = data.filter((item) => item.activityStatus === "Visible")
            setTotalCount(filterVisibleData)
        } catch (error) {
            message.error(error);
        }
    }
    async function RecentActivity(page) {
        try {
            setLoadingPage(true);
            const data = await getAllActivityByType(apiType, UrlId[1], page, PAGE_SIZE);
            const SortedData = data.sort((a, b) => b.activityId - a.activityId);
            const filterVisibleData = SortedData.filter((item) => item.activityStatus === "Visible")
            const promises = filterVisibleData.map(async (item) => {
                const apiResponse = await fetchCombinedEntityData(item.childEntity, item.childEntityId);
                return { ...item, apiResponse };
            });
            const settledResults = await Promise.allSettled(promises);
            const activityWithApiData = settledResults.map((res) =>
                res.status === "fulfilled"
                    ? res.value
                    : { ...res.value, apiResponse: { childEntityData: undefined } }
            );
            const highlighted = activityWithApiData.map(async (item) => ({
                ...item,
                message: item.message ? (item.childEntity !== "Task" && item.childEntity !== "Note" && item.childEntity !== "Call Log" && item.childEntity !== "Mail" && item.childEntity !== "Meeting")
                    ? await highlightValuesInsideQuotes(item.message) : item.message : item.message
            }));
            const highlightedMessages = await Promise.all(highlighted);
            if (page === 1) {
                setActivity(highlightedMessages);
            } else {
                setActivity((prev) =>
                    mergeUniqueById(prev, highlightedMessages)
                );
            }
        } catch (error) {
            setLoadingPage(false);
            message.error(error);
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await FetchAllAttendeeList()
            setAllattendeeData(data)
        }
        catch (error) {
            setAllattendeeData([])
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            CreatorLedadListApi(),
            CreatorcontactListApi(),
        ])
    };
    const reFetchData = async () => {
        await Promise.allSettled([
            setApiPage(1),
            setTablePage(1),
            RecentActivity(1),
            RecentActivity2(),
        ])
    }
    useEffect(() => {
        if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
            setApiType("Lead")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
            setApiType("Deal")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
            setApiType("Contact")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
            setApiType("Account")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CASE") {
            setApiType("Case")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?FCASE") {
            setApiType("Case")
        }
        fetchAll()
    }, [])
    useEffect(() => {
        if (defaultCurrency) {
            if (refreshTrigger === tabKey) {
                if (NacTrigger !== "trigger") {
                    reFetchData()
                }
            }
        }
    }, [UrlId, apiType, trigger, NacTrigger, defaultCurrency, refreshTrigger, tabKey]);
    const emailClose = () => {
        setEmailPopup(false)
        setPopupType()
        setEmailOpenId()
        setNaCTrigger("CallBack")
    }
    const onSubmitstatus = async (id, status) => {
        try {
            const response = await updateActivityStatus(id, status)
            if (response.status === 200) {
                setActivityId()
                setExpandedItems({})
                message.success("Activity deleted")
                setOpenPopup(false)
                reFetchData()
            }
        }
        catch (error) {
            message.log(error)
        }
    }
    const openConfirmation = (id) => {
        setActivityId(id)
        setOpenPopup(true)
    }
    const handleClose2 = () => {
        setActivityId()
        setOpenPopup(false)
    }
    const [formattedActivities, setFormattedActivities] = useState();
    const processMessages = async () => {
        if (activity.length > 0) {
            const formatted = await Promise.all(
                activity.map(async (item, index) => {
                    const formattedMessage = await formatMessage(item.message, item, index);
                    return { ...item, formattedMessage };
                })
            );
            setFormattedActivities(formatted);
            setLoadingPage(false);
        } else {
            setFormattedActivities([])
            setLoadingPage(false);
        }
    };
    useEffect(() => {
        if (allattendeeData && allLeadList && allContactList && activity) {
            processMessages();
        }
    }, [activity, allattendeeData, allLeadList, allContactList]);
    const emailClose2 = () => {
        setMeetingPopup(false)
        setMeetingOpenId()
        setNaCTrigger("CallBack")
    }
    const handleTableChange = async (page) => {
        if (skipOnChangeRef.current) {
            skipOnChangeRef.current = false;
            return;
        }
        const newTablePage = page;
        if (newTablePage === tablePage) {
            return;
        }
        setTablePage(newTablePage);
        const maxIndexNeeded = newTablePage * PAGE_SIZE;
        if (formattedActivities.length < maxIndexNeeded) {
            skipOnChangeRef.current = false;
            const nextApiPage = apiPage + 1;
            RecentActivity(nextApiPage);
            setApiPage(nextApiPage);
        }
        else {
            setApiPage(newTablePage);
        }
    };
    const handleTableChange2 = async (pagination, navigationType) => {
        skipOnChangeRef.current = true;
        if (isClickingRef.current) return;
        setTablePage(pagination);
        const maxIndexNeeded = pagination * PAGE_SIZE;
        if (formattedActivities.length < maxIndexNeeded) {
            isClickingRef.current = true;
            const nextApiPage = apiPage + 1;
            RecentActivity(nextApiPage);
            setApiPage(nextApiPage);
        }
        else {
            const nextApiPage = navigationType === "prev" ? apiPage - 1 : apiPage + 1
            setApiPage(nextApiPage);
        }
        skipOnChangeRef.current = false;
    };
    const sortedActivities = formattedActivities
        ?.sort((a, b) => {
            const dateA = a.date
                ? moment(convertAndFormatDateTime2(a.date, companyProfile, profile), "YYYY-MM-DD HH:mm")
                : null;
            const dateB = b.date
                ? moment(convertAndFormatDateTime2(b.date, companyProfile, profile), "YYYY-MM-DD HH:mm")
                : null;

            if (!dateA || !dateB) return 0;
            return dateB - dateA;
        });
    const paginatedActivities = sortedActivities?.slice(
        (tablePage - 1) * PAGE_SIZE,
        tablePage * PAGE_SIZE) || [];
    useEffect(() => {
        if (isClickingRef.current && formattedActivities) {
            isClickingRef.current = false;
        }
    }, [formattedActivities]);
    return (
        <>
            {loadingPage ?
                <Card className="DetailsTabCard">
                    <Skeleton active />
                </Card>
                :
                (paginatedActivities?.length > 0 ?
                    <Card className="DetailsTabCard">
                        {/* <div style={{ maxHeight: '619px', overflow: 'hidden' }}>
                    <Scrollbars
                        autoHeight
                        autoHeightMax={619}
                        autoHeightMin={100}
                        style={{ width: '100%' }}
                    > */}
                        <Timeline>
                            {paginatedActivities.map((item) => {
                                return (
                                    <Timeline.Item className='welcome'
                                        dot={item.childEntity ? (
                                            item.childEntity === "Task" ? <TaskIcon height={15} width={15} /> :
                                                item.childEntity === "Meeting" ? <CalendarIcon height={15} width={15} /> :
                                                    item.childEntity === "Note" ? <NotesIcon height={15} width={15} /> :
                                                        item.childEntity === "Mail" ? <EmailIcon height={15} width={15} /> :
                                                            (item.childEntity === "Call log" || item.childEntity === 'Call Log') ? <CallLogIcon height={15} width={15} /> : <></>)
                                            :
                                            item.entity === "Lead" ? <LeadIcon height={15} width={15} /> :
                                                item.entity === "Account" ? <AccountsIcon height={15} width={15} /> :
                                                    item.entity === "Contact" ? <ContactIcon height={15} width={15} /> :
                                                        item.entity === "Case" ? <CaseIcon height={15} width={15} /> :
                                                            item.entity === "Deal" ? <DealIcon height={15} width={15} /> : <></>}
                                        key={item.activityId}
                                        color="#407fe9"
                                    >
                                        <div className='TimeLine-Content'>
                                            <div className="timeline-row">
                                                <div>
                                                    <div>{convertAndFormatDateTime(item.date, companyProfile, profile)}</div>
                                                    <div>{item.formattedMessage}</div>
                                                </div>
                                                <div className="timeline-icon-delete">
                                                    <FeatherIcon
                                                        icon="trash-2"
                                                        size={16}
                                                        className="fetcherDelete-Icon"
                                                        onClick={() => openConfirmation(item.activityId)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Timeline.Item>
                                )
                                // }
                            })}
                        </Timeline>
                        <div style={{ textAlign: "center", marginBottom: 10 }}>
                            <Pagination
                                current={tablePage}
                                pageSize={PAGE_SIZE}
                                total={formattedActivities.length}
                                onChange={handleTableChange}
                                showSizeChanger={false}
                                showTotal={(total, range) => `${range[0]}-${range[1]} of ${totalCount.length} items`}
                                itemRender={(page, type, originalElement) => {
                                    if (type === 'prev') {
                                        const isDisabled = tablePage <= 1;
                                        return (
                                            <span role="button"
                                                tabIndex={0}
                                                className={`customeTable-pagianion ${isDisabled ? 'disabled' : ''}`}
                                                style={{
                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                    opacity: isDisabled ? 0.4 : 1,
                                                    display: 'inline-flex',
                                                    alignItems: 'center'
                                                }}
                                                onKeyDown={(event) => {
                                                    if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
                                                        if (!isDisabled) handleTableChange2(tablePage - 1, "prev")
                                                    }
                                                }}
                                                onClick={(e) => {
                                                    if (!isDisabled) handleTableChange2(tablePage - 1, "prev");
                                                    e.stopPropagation();
                                                }}
                                            >
                                                <FeatherIcon icon="chevron-left" size={16} style={{ marginTop: 5 }} />
                                            </span>
                                        );
                                    }

                                    if (type === 'next') {
                                        const isDisabled = (tablePage * PAGE_SIZE) >= totalCount.length || isClickingRef.current;
                                        return (
                                            <span role="button"
                                                tabIndex={0}
                                                className={`customeTable-pagianion ${isDisabled ? 'disabled' : ''}`}
                                                style={{
                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                    opacity: isDisabled ? 0.4 : 1,
                                                    display: 'inline-flex',
                                                    alignItems: 'center'
                                                }}
                                                onKeyDown={(event) => {
                                                    if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
                                                        if (!isDisabled) handleTableChange2(tablePage + 1, "next")
                                                    }
                                                }}
                                                onClick={(e) => {
                                                    if (!isDisabled) handleTableChange2(tablePage + 1, "next");
                                                    e.stopPropagation();
                                                }}
                                            >
                                                <FeatherIcon icon="chevron-right" size={16} style={{ marginTop: 5 }} />
                                            </span>
                                        );
                                    }

                                    return originalElement; // normal page numbers
                                }}
                            />
                        </div>
                        {/* )} */}
                        {/* </Scrollbars> </div> */}
                    </Card>
                    :
                    <div style={{ padding: "10%" }}>
                        <Empty />
                    </div>)
            }
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} AllNotes={() => reFetchData()} noteValue={noteValue} page={page} setNaCTrigger={setNaCTrigger} />}
            {callLogPopup && <CallLog setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} callLogValue={callLogValue} AllCallLogs={() => reFetchData()} setNaCTrigger={setNaCTrigger} />}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Email Message"
                open={emailPopup}
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => emailClose()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    emailClose()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                width="70%">
                <MailDetailView detailsId={emailOpenId} detailsPage={popupType} Comefrom="Entity" setNaCTrigger={setNaCTrigger} />
            </Drawer>
            {openPopup && <Modal
                title="Delete Confirmation"
                open={openPopup}
                onCancel={handleClose2}
                maskClosable={false}
                footer={[<div>
                    <Button htmlType="submit" size="small" className="gray-button" onClick={() => handleClose2()}>
                        <FeatherIcon icon="x" /> Cancel
                    </Button>
                    <Button htmlType="submit" size="small" onClick={() => onSubmitstatus(activityId, "Hide")} className='red-button'>
                        <FeatherIcon icon="trash-2" /> Delete
                    </Button>
                </div>]}
            >
                Are you sure you want to delete this activity? This action cannot be undone
            </Modal>}
            <RelatedMeetingPopup modelOpen={meetingPopup} handleClose={emailClose2} Meeting={meetingOpenId} emailCongifDetail={emailapiValues} />

        </>
    );
}
ActivityTimeline.propTypes = {
    UrlId: PropTypes.array.isRequired,
    trigger: PropTypes.string.isRequired,
    emailactiontype: PropTypes.object.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(ActivityTimeline)